// (function() {
//   function bloquearAcao() {
//     // Bloquear clique direito (desktop e toque longo mobile)
//     document.oncontextmenu = function() {
//       return false;
//     };

//     // Bloquear seleção de conteúdo (desktop e mobile)
//     document.onselectstart = function() {
//       return false;
//     };

//     // Bloquear teclas (F12, Ctrl+Shift+I/J e Ctrl+U)
//     document.onkeydown = function(e) {
//       if (
//         e.keyCode === 123 || // F12
//         (e.ctrlKey && e.shiftKey && (e.keyCode === 73 || e.keyCode === 74)) || // Ctrl+Shift+I/J
//         (e.ctrlKey && e.keyCode === 85) // Ctrl+U
//       ) {
//         return false;
//       }
//     };

//     let touchDuration = 500;
//     let touchTimeout;

//     document.addEventListener('touchstart', function(e) {
//       if (e.target.tagName === 'IMG') {
//         touchTimeout = setTimeout(function() {
//           e.preventDefault();
//           // Opcional: alert para o usuário
//           // alert('Download de imagens não permitido.');
//         }, touchDuration);
//       }
//     }, { passive: false });

//     document.addEventListener('touchend', function(e) {
//       clearTimeout(touchTimeout);
//     });
//   }

//   document.addEventListener('DOMContentLoaded', bloquearAcao);
//   document.addEventListener('shopify:section:load', bloquearAcao);
//   document.addEventListener('shopify:section:select', bloquearAcao);
// })();


(function () {
  function bloquearCanvasEImg() {
    // Bloquear clique direito apenas em canvas e img
    document.addEventListener("contextmenu", function (e) {
      if (e.target.tagName === "CANVAS" || e.target.tagName === "IMG") {
        e.preventDefault();
      }
    });

    // Bloquear toque longo em canvas e img no mobile
    let touchDuration = 500;
    let touchTimeout;

    document.addEventListener(
      "touchstart",
      function (e) {
        if (e.target.tagName === "CANVAS" || e.target.tagName === "IMG") {
          touchTimeout = setTimeout(function () {
            e.preventDefault();
          }, touchDuration);
        }
      },
      { passive: false }
    );

    document.addEventListener("touchend", function () {
      clearTimeout(touchTimeout);
    });
  }

  document.addEventListener("DOMContentLoaded", bloquearCanvasEImg);
  document.addEventListener("shopify:section:load", bloquearCanvasEImg);
  document.addEventListener("shopify:section:select", bloquearCanvasEImg);
})();

document.addEventListener('contextmenu', function(event) {
  event.preventDefault();  // Bloqueia o menu do botão direito
});

